import { Routes } from '@angular/router';
import { pagesRoutes } from './pages/pages.routes';
import { settingsRoutes } from './settings/settings.routes';
import { authGuard, checkAbandoneOrNoAddressdUser, maintenanceGuard, checkMembershipPermissions, checkNoPaymentMethodUser, maintenanceOffGuard } from './shared/guards/auth-guard.guard';
import { HomeComponent } from './home/home.component';
import { accountRecoveryRoutes } from './authentication/account-recovery/account-recovery.routes';
import { signupV2Routes } from './authentication/signup-v2/signup-v2.routes';
import { canDeactivateGuard } from './shared/guards/deactivate/can-deactivate.guard';
import { shopResolver } from './resolvers/shop.resolver';
import { productResolver } from './resolvers/product.resolver';

// Lazy chunks — keep everything but the landing page out of the initial bundle.
// HomeComponent stays eager because `/` is the entry route; any loadComponent
// delay there is visible as a blank flash on first visit.
const loadShopComponent = () =>
  import('./shop/shop.component').then(m => m.ShopComponent);
const loadCustomBoxComponent = () =>
  import('./shared/custom-box/custom-box.component').then(m => m.CustomBoxComponent);

export const routes: Routes = [
  {
    path: 'maintenance',
    title: 'Maintenance',
    loadComponent: () => import('./maintenance/maintenance.component').then(m => m.MaintenanceComponent),
    canActivate: [maintenanceOffGuard]
  },
  {
    path: 'ecommerce-admin/:token',
    title: 'Ecommerce Admin',
    loadComponent: () => import('./authentication/ecommerce-admin/ecommerce-admin.component').then(m => m.EcommerceAdminComponent),
    canActivate: [maintenanceGuard]
  },
  {
    path: '',
    component: HomeComponent,
    canActivate: [maintenanceGuard]
  },
  {
    path: 'login',
    title: 'Log In',
    loadComponent: () => import('./authentication/login/login.component').then(m => m.LoginComponent),
    canActivate: [maintenanceGuard, authGuard]
  },
  ...signupV2Routes,
  ...pagesRoutes,
  ...settingsRoutes,
  ...accountRecoveryRoutes,
  {
    path: 'shop',
    loadComponent: loadShopComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
    canActivateChild: [maintenanceGuard],
    resolve: { shop: shopResolver }
  },
  {
    path: 'shop/:category',
    loadComponent: loadShopComponent,
    canActivate: [maintenanceGuard, checkMembershipPermissions, checkAbandoneOrNoAddressdUser],
    resolve: { shop: shopResolver }
  },
  {
    path: 'shop/custom-box/:bundleEditionType/:productId',
    title: 'Shop Custom Box',
    loadComponent: loadCustomBoxComponent,
    pathMatch: 'full',
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser],
    canDeactivate: [canDeactivateGuard]
  },
  {
    path: 'shop/:category/:subcategory/:product',
    title: 'Product',
    loadComponent: () => import('./product/product.component').then(m => m.ProductComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions],
    resolve: { product: productResolver }
  },
  {
    path: 'favorites',
    title: 'Favorites',
    loadComponent: () => import('./fav-products/fav-products.component').then(m => m.FavProductsComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions]
  },
  {
    path: 'preferences',
    title: 'Preferences',
    loadComponent: () => import('./authentication/signup/preferences-signup/preferences-signup.component').then(m => m.PreferencesSignupComponent),
    canActivate: [maintenanceGuard],
    canDeactivate: [canDeactivateGuard]
  },
  {
    path: 'buy-again',
    title: 'Buy again',
    loadComponent: () => import('./buy-again-products/buy-again-products.component').then(m => m.BuyAgainProductsComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions]

  },
  {
    path: 'order',
    title: 'Order',
    loadComponent: () => import('./side-checkout/side-checkout.component').then(m => m.SideCheckoutComponent),
    canActivate: [maintenanceGuard, checkMembershipPermissions],
  },
  {
    path: 'terms-and-conditions',
    title: 'Terms & Conditions',
    loadComponent: () => import('./authentication/signup/terms-and-conditions/terms-and-conditions.component').then(m => m.TermsAndConditionsComponent),
    canActivate: [maintenanceGuard]
  },

  {
    path: 'order/custom-box/:bundleEditionType',
    title: 'Order Custom Box',
    loadComponent: loadCustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'order/custom-box/:bundleEditionType/:productId',
    title: 'Order Custom Box',
    loadComponent: loadCustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'product/custom-box/:bundleEditionType/:productId',
    title: 'Product Custom Box',
    loadComponent: loadCustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'signup/custom-box/:bundleEditionType/:productId',
    title: 'Sign Up Custom Box',
    loadComponent: loadCustomBoxComponent,
    canActivate: [maintenanceGuard, checkNoPaymentMethodUser]
  },
  {
    path: 'free-eggs',
    loadComponent: () => import('./campaign/campaign.component').then(m => m.CampaignComponent)
  },
  {
    path: 'free-eggs10',
    loadComponent: () => import('./free-eggs-10/free-eggs-10.component').then(m => m.FreeEggs10Component)
  },
  {
    path: 'sms-opt-in',
    loadComponent: () => import('./shared/blank-component/blank.component').then(m => m.BlankComponent),
  },
  { path: '**', redirectTo: '' },
];
